<a href="#" class="scrollToTop hoverable hvr-wobble-vertical" style="display:none;"><i class="mdi mdi-arrow-up"></i></a>